// @ts-nocheck
/* eslint-disable */
import { createI13nNode } from 'react-i13n';
import { Link } from 'react-router-dom';

// NOTE: This component is DEPRECATED, please use Link common component instead

const I13nLink = createI13nNode(
  Link,
  {
    isLeafNode: true,
    bindClickEvent: false,
    follow: true,
  },
  { skipUtilFunctionsByProps: true }
);

export default I13nLink;
